import { IAndroidWatchesFormContext } from './androidWatchesFormContext';

export enum AndroidWatchesFormActionsTypes {
	SET_MESSAGES = 'SET_MESSAGES',
	SET_IMPORTANT_MESSAGES = 'SET_IMPORTANT_MESSAGES',
	SET_INFORMATION_MESSAGES = 'SET_INFORMATION_MESSAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetMessages {
	type: AndroidWatchesFormActionsTypes.SET_MESSAGES;
	payload: {
		importantMessages: IAndroidWatchesFormContext['importantMessages'];
		informationMessages: IAndroidWatchesFormContext['informationMessages'];
	};
}

interface ISetImportantMessages {
	type: AndroidWatchesFormActionsTypes.SET_IMPORTANT_MESSAGES;
	payload: {
		importantMessages: IAndroidWatchesFormContext['importantMessages'];
	};
}

interface ISetInformationMessages {
	type: AndroidWatchesFormActionsTypes.SET_INFORMATION_MESSAGES;
	payload: {
		informationMessages: IAndroidWatchesFormContext['informationMessages'];
	};
}

interface ISetDataForSubmit {
	type: AndroidWatchesFormActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IAndroidWatchesFormContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: AndroidWatchesFormActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IAndroidWatchesFormContext['typeOfModalWindow'];
	};
}

export type TAndroidWatchesFormAction =
	| ISetMessages
	| ISetImportantMessages
	| ISetInformationMessages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
